<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Categoria</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:end" class="textoSubtitulo">Conf_cat_ctg</p>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="mt-2 col-md-12"></div>

      <b-container fluid="">
        <b-row>
          <b-col>
            <div>
              <loading :active.sync="loadingCategoria"></loading>
              <b-row class="text-center mt-4">
                <b-col cols="1" md="3">
                </b-col>
          
                <b-col cols="9" md="6" >
                  <b-row class="contenedorTablaSinColor" style="background:white ">
                    <b-col cols="10" lg="11" class="pr-0">
                      <b-input-group class="pl-3" >
                        <b-form-input
                            class="input-filter"
                            maxLength="15"
                            v-model="filtro.descripcion"
                            type="search"
                            id="filterInput"
                            responsive
                            placeholder="Búsqueda de categorias"
                            @keydown.enter.native="buscarCategorias()"
                        >
                        </b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col cols="2" lg="1" class="pl-0">
                      <b-button
                          class="mt-1 pb-1"
                          size="sm"
                          variant="info"
                          :disabled="loading"
                          @click="buscarCategorias"
                          responsive
                      >
                        <span v-if="!loading"
                        >
                          <em class="buscar_svg primary sm"></em>
                        </span>
                        <span v-else><b-spinner small></b-spinner></span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
          
                <b-col cols="1" class="text-left mt-auto mb-auto">
                  <b-button
                      v-if="$localStorageService.can('Conf_cat_ctg_alta')"
                      variant="primary"
                      v-b-tooltip.hover
                      title="Alta de categoria"
                      class="paddingbotones botonesAzulFuerte"
                      @click="altaCategoria()"
                      responsive
                  ><em class="vale_svg icon-boton"></em>
                  </b-button>
                </b-col>
              </b-row>
          
          
                  <b-row >
                    <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                      <b-table
                          :hover="true"
                          :small="true"
                          style="font-size: 12px !important; padding: 0.1rem;"
                          responsive
                          fixed
                          :fields="fields"
                          :items="items"
                          :per-page="registrosPorPagina"
                          :current-page="currentPage"
                          thead-tr-class="columnasTablaSinColorLetter"
                          >
          
                        <template v-slot:cell(Acciones)="row" style="width: 200px">
                          <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                                    v-if="row.item.registroActivo && $localStorageService.can('Conf_cat_ctg_editar')"
                                    v-b-tooltip.hover
                                    title="Editar"
                                    @click="llamarModal(row.item)">
                            <em class="editar_svg sm"></em>
                          </b-button>
          
                          <b-button size="sm" variant="outline-success" class="mr-1 mt-1 marginbotones"
                                    v-if="!row.item.registroActivo && $localStorageService.can('Conf_cat_ctg_reactivar')"
                                    v-b-tooltip.hover
                                    title="Activar Categoria"
                                    @click="activarDesactivar(row.item)">
                            <em class="fa fa-undo"></em>
                          </b-button>
                          <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                                    v-else-if="$localStorageService.can('Conf_cat_ctg_inactivar')"
                                    v-b-tooltip.hover
                                    title="Dar de baja"
                                    @click="activarDesactivar(row.item)">
                            <em class="eliminar_svg icon-boton"></em>
                          </b-button>
                        </template>
                      </b-table>
                      <div align="center" v-if="loading">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                      </div>
                      <b-col v-else>
                        <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
                      </b-col>
                    </b-col>
                    <div class="mt-2 w-100 flex justify-content-center align-items-end">
                      <b-pagination
                          align="center"
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="registrosPorPagina"
                      ></b-pagination>
                    </div>
                  </b-row>
          
          
          
              <b-modal
                  v-model="mostrarModal"
                  size="md"
                  class="redondeo"
                  centered
                  :no-close-on-backdrop="true"
                  hide-footer>
                <template #modal-header="{ ok, close }">
                  <b-row>
                    <div class="seccionTitle mLeft h5">
                      <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
                      <div class="headerTxt mLeft">{{titulo}}</div>
                    </div>
                  </b-row>
                </template>
                    <div>
                      <b-form-group align="left">
                        <label class="letter">Descripción de la categoria <validacion/> </label>
                        <b-input-group size="sm">
                          <b-form-input
                              class="redondeo"
                              id="descripcion"
                              placeholder="Ingresa la descripción de la categoria"
                              
                              v-model="descripcion"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <div class="text-center">
                      <b-button
                        class="mt-3 botonesAzulFuerte"
                        variant="primary"
                        style="margin:10px"
                        :disabled="validar()"
                        @click=guardar()>Guardar
                      </b-button>
                      <b-button
                        class="mt-3 botonesGrisFuerte"
                        style="margin:10px"
                        @click=cancelar()>Cancelar
                      </b-button>
                    </div>
              </b-modal>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
  </template>
  
  <script>
  
  import {validationMixin} from "vuelidate";
  import Header from "@/components/Header.vue";
  
  
  export default {
    name: "CategoriaNuevo",
    components: {Header},
  
    mixins: [validationMixin],
    data() {
      return {
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
        loading: false,
        loadingCategoria: false,
  
        fields: [
          {key: "idCategoriaNuevo", label: "ID", sortable: true},
          {key: "descripcion", label: "Descripción", sortable: true},
          "Acciones",
        ],
  
        currentPage: 1,
        items: [],
        registrosPorPagina:10,
  
        mostrarModal: false,
        titulo: "",
  
        objGuardar: {
          idCategoriaNuevo: null,
          descripcion: null,
        },
        descripcion: null,
        filtro: {
          descripcion: '',
        }
      };
    },
    mounted() {
      this.buscarCategorias();
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
      validar(){
        if(this.descripcion != null && this.descripcion != ''){
          return false;
        }else{
          return true;
        }
      },
      altaCategoria() {
        this.mostrarModal = true;
        this.titulo = "Nueva Categoria";
      },
      buscarCategorias() {
        this.currentPage = 1;
        this.loading = true;
        this.items = [];
        this.$http
            .post(this.$api + "categoriaNuevo/obtenerCategoriasNuevos", this.filtro)
            .then((response) => {
              this.items = response.data.data;
            }).finally(() => {
          this.loading = false;
        });
      },
      llamarModal(item) {
        this.objGuardar.idCategoriaNuevo = item.idCategoriaNuevo;
        this.descripcion = item.descripcion;
        this.mostrarModal = true;
        this.titulo = "Modificar categoria";
      },
      cancelar(){
        this.descripcion = null;
        this.mostrarModal = false;
      },
      guardar(){
        this.objGuardar = {idCategoriaNuevo: this.objGuardar.idCategoriaNuevo, descripcion: this.descripcion}
        this.$http
            .post(this.$api + "categoriaNuevo/guardarCategoria", this.objGuardar)
            .then((response) => {
              if (response.status === 200) {
              this.$swal.fire({
                position: "center",
                icon: response.data.data != null ? "success" : "info",
                title: "Aviso",
                text: response.data.data != null ? "Categoria registrada correctamente" : response.data.message,
                showConfirmButton: false,
                timer: 3500,
              });
            }
          }).catch((error)=>{
          console.error(error);
          this.$swal.fire({
            position: "center",
            icon: "error",
            title: "Ocurrio un error al registrar la categoria",
            showConfirmButton: false,
            timer: 3500,
          });
          }).finally(() => {
            this.buscarCategorias()
            this.loading = false;
          });
        this.descripcion = null;
        this.mostrarModal = false;
      },
      activarDesactivar(item) {
        if(!item.registroActivo){
          this.$swal.fire({
            text: '¿Desea activar la categoria?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
    
            preConfirm: () => {
              this.loading = true;
              this.$http.post(this.$api + "categoriaNuevo/activarDesactivar", item.idCategoriaNuevo)
              .then((response) => {
                if (response.data.data) {
                  this.buscarCategorias();
                  this.$swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Se activo la categoria",
                    showConfirmButton: false,
                    timer: 3500,
                  });
                }
              });
            },
          });
        }else{
          const mensaje = '¿Está seguro de desactivar la categoria?';
          this.$swal.fire({
            icon: "warning",
            text: mensaje,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
    
            preConfirm: () => {
              this.loading = true;
              this.$http.post(this.$api + "categoriaNuevo/activarDesactivar", item.idCategoriaNuevo)
              .then((response) => {
                if (response.data.data) {
                  this.buscarCategorias();
                  this.$swal.fire({
                    position: "center",
                    icon: "info",
                    title: "Aviso",
                    text:"Se desactivó la categoria",
                    showConfirmButton: false,
                    timer: 3500,
                  });
                }
              });
            },
          });
        }
      },
    },
    computed: {
      rows() {
        return this.items.length;
      },
  
    },
  
  };
  </script>
  
  <style scoped>

.bCardAgenda {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}
  
  .input-filter,
  .input-filter:focus {
    background: transparent;
    border: 0px;
    box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
  }
  
  .botonesAzulFuerte {
    border-radius: 10rem;
    color: #fff;
    background-color: var(--color-icono);
    border-color: var(--color-icono);
    margin-left: 5%;
  }
  .icon-boton-agenda {
    filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%);
    height: 20px;
    display: block;
  }
  .redondeo{
    border-radius: 10px !important;
  }
  
  .botonesGrisFuerte {
    border-radius: 10rem;
    color: #fff;
    margin-left: 5%;
  }
  .icon-boton {
    filter: brightness(0) invert(1);
    height: 20px;
    display: block;
  }
  .paddingbotones {
    padding: 5px;
  }
  
  .marginbotones{
    border-radius:20px;
  }
  
  .icon-redondo{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .botonConfigEstilo {
    padding-bottom: 4px;
    padding-top: 5px;
    padding-left: 6px;
    padding-right: 7px;
  }

  .redondeo{
    border-radius: 10px !important;
    font-size: 12px;
  }
  </style>